import processReport from '@/assets/js/report/order_pick'
export default {
  methods: {
    async genereatePickReportContent (getObj) {
      if (!getObj) getObj = {}
      let customerLang = (getObj && getObj.customer_language) ? getObj.customer_language : this.$i18n.locale
      let lang = this.$i18n.messages[customerLang].message
      if (getObj) {
        let headers = [
          { text: lang.orders.productNo, value: 'number', width: '15%' },
          { text: lang.customer.name, value: 'producttext', width: '47%' },
          { text: lang.stock.location, value: 'stocks', width: '11%' },
          // { text: lang.whOrder.availQty, value: 'product_available', width: '5%' },
          // { text: lang.order.deliveredQty, value: 'deliveredqty', width: '7%' },
          { text: lang.stock.toDeliver, value: 'qty', width: '9%' },
          { text: lang.common.pickQ, value: 'pickedqty', width: '9%' },
          { text: lang.order.rest, value: 'rest', width: '9%' }
        ]
        let products = await this.getOrderPickProducts(getObj.id, getObj.type, getObj.restcreatedfrom)
        let translationData = {
          confirm: lang.orders.pickList,
          number: lang.order.orderNumber,
          customer: lang.order.customer,
          contact: lang.order.yourContactPerson,
          deliveryAddress: lang.orders.deliveryAddress,
          responsible: lang.deviations.responsible,
          ourreference: lang.orders.ourReference,
          yourreference: lang.orders.yourReference,
          contactPhone: lang.order.contactPhone,
          offerdate: lang.orders.offerDate,
          orderdate: lang.whOrder.orderDate,
          deliverydate: lang.order.shippingDate,
          shipment: lang.customer.shipmentReport,
          paymentTerm: lang.order.paymentTerms,
          deliveryTerm: lang.order.deliveryTerm,
          invoiceTo: lang.orders.invoiceTo,
          invoiceAddress: lang.orders.invoiceAddress,
          days: lang.common.days,
          restorder: lang.orders.restOrderFor,
          saleRef: lang.invoiceReport.saleRef,
          customerNum: lang.unimicro.customerNumber
        }
        let getBase64Content = processReport(headers, products, getObj, translationData)
        return getBase64Content
      }
    },
    getOrderPickProducts (id) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `ordermaterials/get_materials_picklist/${id}`)
          .then((response) => {
            if (response.data) {
              const allMaterials = response.data
              allMaterials.map(x => {
                const qtyValue = x.qty
                const pickedQty = x.pickedqty
                x.qty = this.$formatter.replaceDotWithCommaIfHasDecimal(x.qty)
                x.product_available = this.$formatter.replaceDotWithCommaIfHasDecimal(x.product_available)
                x.deliveredqty = '0'
                x.stocks.map(y => {
                  y.availqty = this.$formatter.replaceDotWithCommaIfHasDecimal(y.availqty)
                })
                if (x.pickedqty > 0) x.deliveredqty = this.$formatter.replaceDotWithCommaIfHasDecimal(x.pickedqty)
                if (qtyValue !== pickedQty) x.qty = qtyValue - pickedQty
                x.updatedon = this.$formatter.formatDate(x.updatedon, 'DD.MM.YYYY', 'DD.MM.YYYY')
                if (x.isfreight) {
                  x.producttext = 'Frakt'
                  x.number = '1000'
                }
                return x
              })
              resolve(allMaterials)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
